export default {
  button: {
    textAlign: 'left'
  }
}
